import { z } from 'zod';

import { schemaEuropaceAntragstellerzuordnung } from '../Antragstellerzuordnung.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#haushalt

	{
		"bic": String,
		"gehoertZuAntragsteller": Antragstellerzuordnung,
		"iban": String,
		"kreditinstitut": String
	}

*/

export const schemaEuropaceKontoverbindung = z.object({
    bic: z.optional(z.string()),
    gehoertZuAntragsteller: z.optional(schemaEuropaceAntragstellerzuordnung),
    iban: z.optional(z.string()),
    kreditinstitut: z.optional(z.string()),
});

export type SchemaEuropaceKontoverbindung = z.infer<typeof schemaEuropaceKontoverbindung>;
